import styled from 'styled-components';
import { LAYOUT, media } from '@app/styles/themes/constants';

export const ChatWrapper = styled.div`
  height: calc(100vh - ${LAYOUT.mobile.headerHeight} - ${LAYOUT.mobile.paddingVertical} * 2);
  overflow: hidden;

  @media only screen and ${media.md} {
    height: calc(100vh - ${LAYOUT.desktop.headerHeight} - ${LAYOUT.desktop.paddingVertical} * 2);
  }

  @media only screen and ${media.xl} {
    height: calc(100vh - ${LAYOUT.desktop.paddingVertical} * 2);
  }

  .ant-card {
    height: 100%;
    overflow: hidden;
  }

  .ant-card-body {
    overflow: hidden;
  }
`;
